/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Infobox } from './Infobox';
import { InfoboxFromJSON, InfoboxFromJSONTyped, InfoboxToJSON } from './Infobox';

/**
 *
 * @export
 * @interface PaginatedInfoboxList
 */
export interface PaginatedInfoboxList {
  /**
   *
   * @type {number}
   * @memberof PaginatedInfoboxList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedInfoboxList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedInfoboxList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Infobox>}
   * @memberof PaginatedInfoboxList
   */
  results: Array<Infobox>;
}

/**
 * Check if a given object implements the PaginatedInfoboxList interface.
 */
export function instanceOfPaginatedInfoboxList(value: object): value is PaginatedInfoboxList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedInfoboxListFromJSON(json: any): PaginatedInfoboxList {
  return PaginatedInfoboxListFromJSONTyped(json, false);
}

export function PaginatedInfoboxListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedInfoboxList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(InfoboxFromJSON),
  };
}

export function PaginatedInfoboxListToJSON(value?: PaginatedInfoboxList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(InfoboxToJSON),
  };
}
